import React from 'react';

import PropTypes from 'prop-types';

import { FormField } from 'components/FormHelper/FormField';

import { BRANCH_TYPE } from 'global/constants';

import { isRegisteredBranchMain } from 'utils/InstallerUtils';

export const DEBExpertPopupValiditySection = ({ formik, installerStatusSummary }) => {
  return (
    <>
      {!isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.ENERGY) &&
        formik.values.isExpertEnergyActive && (
          <div className="popup-content__popup-field">
            <FormField
              name="expertEnergyValidityDate"
              formik={formik}
              label="Strom-Ausweis gültig bis*"
              oldValue=""
              fullWidth
            />
          </div>
        )}
      {!isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.GAS) &&
        formik.values.isExpertGasActive && (
          <div className="popup-content__popup-field">
            <FormField
              name="expertGasValidityDate"
              formik={formik}
              label="Gas-Ausweis gültig bis*"
              oldValue=""
              fullWidth
            />
          </div>
        )}
    </>
  );
};

DEBExpertPopupValiditySection.propTypes = {
  formik: PropTypes.object.isRequired,
  installerStatusSummary: PropTypes.object.isRequired,
};
